// reducers/sharedSafariReducer.js

export const initialParksViewState = {
    parkDetail: null,
    parkViewLoading: true,
    parkViewError: '',
    //park wise packages
    parkWisePackages: [],
    packageSummary: {},
    filters: {},
    pageIndex: 1,
    //park wise safari    
    parkSharedSafariData: [],
    safariSummary: {},
    safariFilters: {},
    safariPageIndex: 1,

    //park review
    parkReviewData: [],
    parkViewReviewModalToggle: false,
    suggCorrToggle: false
};

export const parksViewReducer = (state = initialParksViewState, action) => {
    switch (action.type) {
        case "SET_PARK_VIEW_LOADING":
            return {
                ...state,
                parkViewLoading: typeof action.payload === "boolean" ? action.payload : state.parkViewLoading,
            };
        case 'SET_PARKS_VIEW_DETAILS':
            return {
                ...state,
                parkDetail: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.parkDetail,
            };
        case "SET_PARKS_VIEW_ERROR":
            return {
                ...state,
                parkViewError: typeof action.payload === "boolean" ? action.payload : state.parkViewError,
            };
        case "SET_PARK_VIEW_REVIEW_MODAL_TOGGLE":
            return {
                ...state,
                parkViewReviewModalToggle: typeof action.payload === "boolean" ? action.payload : state.parkViewReviewModalToggle,
            };
        case "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE":
            return {
                ...state,
                suggCorrToggle: typeof action.payload === "boolean" ? action.payload : state.suggCorrToggle,
            };

        case 'SET_PARKS_VIEW_PACKAGE_DATA':
            return {
                ...state,
                parkWisePackages: Array.isArray(action.payload)
                    ? action.payload
                    : state.parkWisePackages,
            };
        case 'APPEND_PARKS_VIEW_PACKAGE_DATA':
            return {
                ...state,
                parkWisePackages: [
                    ...state.parkWisePackages,
                    ...action.payload.filter(newItem =>
                        newItem.id && !state.parkWisePackages.some(existing => existing.id === newItem.id)
                    ),
                ],
            };
        case 'SET_PARKS_VIEW_PACKAGES_SUMMARY':
            return {
                ...state,
                packageSummary: action.payload && typeof action.payload === 'object' ? action.payload : state.packageSummary,
            };

        case 'SET_PARKS_VIEW_PACKAGE_FILTER':
            return {
                ...state,
                filters: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.filters,
            };
        case 'UPDATE_PARKS_VIEW_PACKAGE_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        case 'SET_PARKS_VIEW_PACKAGE_PAGE_INDEX':
            return {
                ...state,
                pageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndex,
            };

        //Park wise Share Safari
        case 'SET_PARKS_VIEW_SHARED_SAFARI_DATA':
            return {
                ...state,
                parkSharedSafariData: Array.isArray(action.payload)
                    ? action.payload
                    : state.parkSharedSafariData,
            };

        case 'APPEND_PARKS_VIEW_SHARED_SAFARI_DATA':
            return {
                ...state,
                parkSharedSafariData: [
                    ...state.parkSharedSafariData,
                    ...action.payload.filter(
                        newItem => !state.parkSharedSafariData.some(existing => existing.id === newItem.id)
                    ),
                ],
            };
        case 'SET_PARKS_VIEW_SAFARI_FILTER':
            return {
                ...state,
                safariFilters: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.safariFilters,
            };
        case 'UPDATE_PARKS_VIEW_SAFARI_FILTER':
            return {
                ...state,
                safariFilters: {
                    ...state.safariFilters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        case 'SET_PARKS_VIEW_SHARED_SAFARI_SUMMARY':
            return {
                ...state,
                safariSummary: action.payload && typeof action.payload === 'object' ? action.payload : state.safariSummary,
            };
        case 'SET_PARKS_VIEW_SHARED_SAFARI_PAGE_INDEX':
            return {
                ...state,
                safariPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.safariPageIndex,
            };
        default:
            return state;
    }
};
